


































import { Component, Vue } from 'vue-property-decorator';

import AlternativeIndex from '@/components/Question/AlternativeIndex/index.vue';
import FeedbackUser from '@/components/FeedbackUser/index.vue';

import { ISummationAlternative } from '@/globalInterfaces/Questions';

@Component({
  components: {
    AlternativeIndex,
    FeedbackUser,
  },
})
export default class ResolutionSummation extends Vue {
  get shuffledAlternativesCorrect() {
    const alternatives: ISummationAlternative[] = this.$store.getters.summationQuestion.shuffledAlternatives;

    return alternatives.filter((alternative: ISummationAlternative) => alternative.validated === 1);
  }

  get summationAnswer() {
    return this.shuffledAlternativesCorrect.reduce((acc: number, alternative: ISummationAlternative) => (acc + alternative.index), 0);
  }

  getOperator(index: number) {
    return index <= this.shuffledAlternativesCorrect.length - 1 ? ' + ' : '';
  }
}
